import { render, staticRenderFns } from "./BayOnDeck.vue?vue&type=template&id=0f0a8f45&scoped=true"
import script from "./BayOnDeck.vue?vue&type=script&lang=ts"
export * from "./BayOnDeck.vue?vue&type=script&lang=ts"
import style0 from "./BayOnDeck.vue?vue&type=style&index=0&id=0f0a8f45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a8f45",
  null
  
)

export default component.exports